var ConditionalBlockModel = /** @class */ (function () {
    function ConditionalBlockModel(data) {
        if (data === void 0) { data = undefined; }
        if (data) {
            this.col_name = data['col_name'] ? data['col_name'] : '';
            this.fieldType = data['fieldType'] ? data['fieldType'] : '';
        }
    }
    return ConditionalBlockModel;
}());
export { ConditionalBlockModel };
